import { Component, OnDestroy, ElementRef } from '@angular/core';
import { I18nService } from '@app/shared/i18n/i18n.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { PostItService } from './../postIt.service';
import { CommonService } from "@app/shared/common/common.service";
import cloneDeep from 'lodash.clonedeep';

declare var $: any;

@Component({
  selector: 'notes-container',
  styles: [`
    .notes-box .note-card {
      position: fixed;
      width: 200px;
      height: auto;
      top: 20px;
      left: 20px;
      box-shadow: 0 1px 15px rgba(0,0,0,.5);
      cursor: pointer;
      z-index: 99;
      min-height: 100px;
    }
    .note-creator {
      padding: 20px;
    }
    .title {
      font-weight: bold;
      color: rgba(0,0,0,0.8);
    }
    .full {
      height: 100px;
    }
    .note-card {
      padding: 15px;
      width: 100%;
      position: relative;
      text-overflow: ellipsis;
      overflow-wrap: break-word;
    }
    .title {
      font-size: 1.2rem;
      font-weight: bold;
      text-align: left;
      color: rgba(0,0,0,0.8);
    }
    .value {
      text-align: left;
      font-size: 1.4rem;
      font-weight: 200;
      word-wrap: break-word;
    }
    .icon {
      display: none;
      position: absolute;
      color: #333;
      border: 1px solid #f5f5f5;
      background-color: #fff;
      font-size: 14px;
      top: -10px;
      left: -10px;
      width: 25px;
      height: 25px;
      border-radius: 100%;
      cursor: pointer;
      text-align: center;
      line-height: 22px;
      box-shadow: 0 1px 15px rgba(0,0,0,.1); 
    }
    .note-card:hover .icon {
      display: block;
    }
    .note-card p {
      line-height: normal;  
      margin: 0;
      font-size: 14px;
    }
    .note-card h3 {
      margin-bottom: 10px;
      font-weight: 600;
      font-size: 18px;
    }
  `],
   template: `<div class="center-xs notes">
   <div class="creator">
     <div class="note-creator" [ngStyle]="{'background-color': newNote.color}">
       <form [attr.id]="newNote.noteid" (ngSubmit)="onCreateNote()">
         <div class="form-group">
           <input type="text" [(ngModel)]="newNote.title" name="newNoteTitle" [placeholder]="titlePlaceholder" class="form-control">
         </div>
         <div class="form-group">
           <input type="text" [(ngModel)]="newNote.value" name="newNoteValue" [placeholder]="takeNote" class="form-control">
         </div>
         <div class="clearfix"></div>
         <div class="actions row margin-top-5">
           <div class="col-xs-3">
           </div>
           <div class="text-right col-xs-9">
             <button type="button" (click)="Cancel()" class="btn btn-primary btn-clr margin-right-8 margin-bottom-10 accounting-buttons invoice-btn-align">{{cancel}}</button>
             <button type="submit" class="btn btn-primary btn-clr margin-right-8 margin-bottom-10 accounting-buttons invoice-btn-align">{{submit}}</button>
           </div>          
         </div>
       </form>
     </div>
   </div>
   <div class="notes notes-box hideshow">
     <div ngDraggable (movingOffset)="onMoving($event)" (endOffset)="onMoveEnd($event)" class="note-card" *ngFor="let note of notes; let i = index"  (click)="editNote($event,note.postitId)" [ngStyle]="{'top': note.top+'px','left': note.left+'px','background-color': note.color}">
       <div class="icon completeIcon" (click)="onChecked($event,note.postitId)" title="Completed">
         <i class="fa fa-check completeIcon" (click)="onChecked($event,note.postitId)" title="Completed"></i>
       </div>
       <h3 class="margin-top-0">
         {{ note.titel }}
       </h3>
       <p>
         {{ note.memo }}
       </p>
     </div>
   </div>
 </div>`,
})
export class NotesComponent implements OnDestroy {
  notes = [];
  id = 0;
  noteid;
  endOffset = { x: 0, y: 0 };
  titlePlaceholder='Title';
  takeNote ='Take a note...';
  submit = 'Submit';
  cancel = 'Cancel';
  langChangeSubscription: Subscription;
  windowHeight;
  j = 0;

  constructor(private _elementRef: ElementRef,private i18nService:I18nService, private postItService:PostItService, private commonService: CommonService) {
    this.getNotes();
    this.titlePlaceholder=this.i18nService.getTranslation('common_title');
    this.takeNote=this.i18nService.getTranslation('common_all_note_popup_take_note');
    this.submit=this.i18nService.getTranslation('common_submit');
    this.cancel=this.i18nService.getTranslation('common_cancel');
    this.langChangeSubscription = this.i18nService.langChangeEvent.subscribe(langObj =>{
      setTimeout(() => {
      this.onLangChange(langObj)
      }, 500);
    });
     
    this.windowHeight = $( window ).height();
    if(JSON.parse(localStorage.getEncryptedItem('notesVisible')) != true) {
      setTimeout(() => {
        $('.notes.notes-box').addClass('hideshow');
        $('.sticky-notes .changeiclass i').addClass('fa-eye-slash');
        $('.sticky-notes .changeiclass i').removeClass('fa-eye');
        $('.sticky-notes .changeiclass').attr('title',this.i18nService.getTranslation("common_all_stickyNotes_show"));
      }, 200);
    }
  }

  colors: string[] = ['#fff2b5', '#c7efc4', '#ffc3f4', '#dec6fb', '#c4e5ff']

  newNote = {
    title: '',
    value: '',
    color: 'white',
    id: 0,
    noteid: ''
  };
  onLangChange(langObj) {
    this.titlePlaceholder=this.i18nService.getTranslation('common_title');
    this.takeNote=this.i18nService.getTranslation('common_all_note_popup_take_note');
    this.submit=this.i18nService.getTranslation('common_submit');
    this.cancel=this.i18nService.getTranslation('common_cancel');
  }
  
  onChecked(e, id) {
    let formData = new FormData();
    formData.append("postitId", id);
    formData.append('userId',localStorage.getEncryptedItem('loginId'));
    formData.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
    formData.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
    let object = this.commonService.createObject(formData)
    let token = this.commonService.createToken(object)
    let encryptedToken = this.commonService.encrypt(token)
    let encrData = new FormData()
    encrData.append("encrToken", encryptedToken);
      this.postItService.deleteNote(encrData).subscribe((data:any) => {
        if(!data.status && data.isUnauthenticated) {
          this.commonService.logout();
          
          return false;
        }
        localStorage.setEncryptedItem("lastRequestTime",data.RESPONSETIME);
        this.getNotes();
      }, error => {});
  }

  onMoveEnd(event) {
    setTimeout(() => {
      $("body").removeClass("moving")
    })
    this.endOffset.x = event.x;
    this.endOffset.y = event.y;
  }

  onMoving(event) {
    $("body").addClass("moving")
  }

  getNotes() {
    let formData = new FormData();
    formData.append("instanceId", localStorage.getEncryptedItem('instanceId'));
    formData.append("companyId",localStorage.getEncryptedItem('companyId'));
    formData.append("companyUserId", localStorage.getEncryptedItem('companyUserId'));
    let object = this.commonService.createObject(formData)
    let token = this.commonService.createToken(object)
    let encryptedToken = this.commonService.encrypt(token)
    let encrData = new FormData()
    encrData.append("encrToken", encryptedToken);
    this.postItService.getNotes(encrData).subscribe((data:any) => {
      this.notes = cloneDeep(data.DATA.POSTIT);
      for(let i=0;i<=this.notes.length-1;i++) {
        
        
        this.notes[i]["top"] = (i+1)%10 != 0 ? ((i+1)%10)*50 : (i%10)*50 + 50;
        this.notes[i]["left"] = (i+1)%10 != 0 ? Math.floor(((i+1)/10))*200+20 + Math.floor(((i+1)/10))*10 : Math.floor((i/10))*200+20 + Math.floor(((i)/10))*10;
        this.notes[i]["color"] = this.notes[i].color;
      }
    }, error => {});
  }

  editNote(e, id) {
    
    if (!$("body").hasClass("moving")&&!$(event.target).hasClass('completeIcon')) {
      $('notes-container').addClass('active');
      $('notes-container .creator').css('display', 'block');
      for (let i = 0; i < this.notes.length; i++) {
        if (id == this.notes[i].postitId) {
          this.newNote.title = this.notes[i].titel;
          this.newNote.value = this.notes[i].memo;
          this.newNote.color = this.notes[i].color;
          this.newNote.noteid = this.notes[i].postitId;
          break;
        }
      }
      
    }
  }

  onCreateNote() {
    const { title, value, color, id, noteid } = this.newNote;

    if (this.newNote.noteid == '') {
      if (this.newNote.title != '' || this.newNote.value != '') {
        if (this.newNote.title == '') {
          this.newNote.title = this.newNote.value;
        }
        let formData = new FormData();
        formData.append("instanceId", localStorage.getEncryptedItem('instanceId'));
        formData.append("companyId",localStorage.getEncryptedItem('companyId'));
        formData.append("companyUserId", localStorage.getEncryptedItem('companyUserId'));
        formData.append("title", this.newNote.title);
        formData.append("memo", this.newNote.value);
        formData.append("color", this.newNote.color);
        formData.append('userId',localStorage.getEncryptedItem('loginId'));
        formData.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
        formData.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
        let object = this.commonService.createObject(formData)
        let token = this.commonService.createToken(object)
        let encryptedToken = this.commonService.encrypt(token)
        let encrData = new FormData()
        encrData.append("encrToken", encryptedToken);
        this.postItService.createNote(encrData).subscribe((data:any) => {
          if(!data.status && data.isUnauthenticated) {
            this.commonService.logout();
            
            return false;
          }
          localStorage.setEncryptedItem("lastRequestTime",data.RESPONSETIME);
              this.getNotes();
          this.Cancel();
        }, error => {});
      }
    } else {
      let formData = new FormData();
      formData.append("postitId", this.newNote.noteid);
      formData.append("title", this.newNote.title);
      formData.append("memo", this.newNote.value);
      formData.append("color", this.newNote.color);
      formData.append('userId',localStorage.getEncryptedItem('loginId'));
      formData.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
      formData.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
      let object = this.commonService.createObject(formData)
      let token = this.commonService.createToken(object)
      let encryptedToken = this.commonService.encrypt(token)
      let encrData = new FormData()
      encrData.append("encrToken", encryptedToken);
      this.postItService.editNote(encrData).subscribe((data:any) => {
        if(!data.status && data.isUnauthenticated) {
          this.commonService.logout();         
          return false;
        }
        localStorage.setEncryptedItem("lastRequestTime",data.RESPONSETIME);
        this.getNotes();
        this.Cancel();
      }, error => {});
    }
    $('.notes.notes-box').removeClass('hideshow');
    $('.sticky-notes .changeiclass i').removeClass('fa-eye-slash');
    $('.sticky-notes .changeiclass i').addClass('fa-eye');
    $('.sticky-notes .changeiclass').attr('title',this.i18nService.getTranslation("common_all_stickyNotes_hide"));
    this.reset();
  }

  Cancel() {
    $('notes-container').removeClass('active');
    $('notes-container .creator').css('display', 'none');
    this.reset();
  }

  reset() {
    this.newNote = {
      title: '',
      value: '',
      color: 'white',
      id: this.id,
      noteid: '',
    };
  }

  onColorSelect(color: string) {
    this.newNote.color = color;
  }

  ngOnDestroy() {
  }

};
